import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-default-react-imports */
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { Children, isValidElement, cloneElement, createContext, useState } from 'react';
import { useTranslations } from '../../hooks/useTranslations';
import faqsAnswersTranslations from 'i2l?query=sporks!pricing-pages-ui/lang/faqsAnswers/en.lyaml';
import { defaultTranslationsStatus } from '../../interfaces/TranslationsContext';
import { H2 } from 'UIComponents/elements/headings';
export const TranslationsContext = /*#__PURE__*/createContext(defaultTranslationsStatus);
const QuestionContainer = styled.div.withConfig({
  displayName: "Faq__QuestionContainer",
  componentId: "a75vqz-0"
})(["width:1000px;margin-right:auto;margin-left:auto;position:relative;margin-top:60px;padding-top:55px;padding-bottom:95px;clear:both;", ";", ";"], breakpoint.cs(_t || (_t = _`
    width: 800px;
  `)), breakpoint.tabletPortrait(_t2 || (_t2 = _`
    width: 94%;
  `)));
const QuestionContent = styled.div.withConfig({
  displayName: "Faq__QuestionContent",
  componentId: "a75vqz-1"
})(["z-index:1;position:relative;"]);
const Title = styled(H2).withConfig({
  displayName: "Faq__Title",
  componentId: "a75vqz-2"
})(["font-weight:600;line-height:44px;text-align:center;margin-top:0;margin-bottom:35px;", ";"], breakpoint.tabletPortrait(_t3 || (_t3 = _`
    text-align: center;
    margin: 35px auto;
  `)));

const Faq = ({
  children
}) => {
  const [shouldLoadTranslations, setShouldLoadTranslations] = useState(false);
  const {
    isReady
  } = useTranslations(faqsAnswersTranslations, shouldLoadTranslations);

  const handleLoadTranslations = () => {
    if (!shouldLoadTranslations) {
      setShouldLoadTranslations(true);
    }
  };

  const childrenWithProps = Children.map(children, child => {
    if ( /*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement(
      /* Replace with QuestionProps once Question.js is typed */
      child, {
        onQuestionClick: handleLoadTranslations
      });
    }

    return child;
  });
  return /*#__PURE__*/_jsx(QuestionContainer, {
    "data-selenium-id": "faq-container",
    children: /*#__PURE__*/_jsxs(QuestionContent, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.title"
        })
      }), /*#__PURE__*/_jsx(TranslationsContext.Provider, {
        value: {
          isReady
        },
        children: childrenWithProps
      })]
    })
  });
};

export default Faq;